import type { DeepPartial } from '@luna/utils-ts';

import type { Payments } from './Payments';

export const CZ: DeepPartial<Payments> = {
    shouldLoadBanks: true,
    redoReplyEngine: 'paymentService',
    ignoreLeadingZerosInAccountNumber: true,
    checkDomesticMatchString:
        /^[\w 0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyzáßäčďéěíĺľňóöôřŕšťúůüýžÁÄČĎÉĚÍĹĽŇÓÖÔŘŔŠŤÚŮÜÝŽ,.;:!?@&+\-*/()_#]+$/.toString(),
    bankCodeInvalidReplaceString: /[^a-zA-Z0-9]/g.toString(),
    hasCollectiveBundle: true,
    maxDaysInFuture: 365,
    checkTransferAllowedForRedo: true,
    useCollectiveSigning: true,
    preferBbanDisplay: true,
    instantPayments: {
        showIcon: true,
        snackbarSuccessStates: ['CLOSED'],
        snackbarFailedStates: ['CANCELLED', 'FAILED'],
        snackbarOverallTimeout: 8000,
        snackbarRepeatDelay: 3000,
        avoidShowingInfoMessages: true,
    },
    isApprovalExecutionAfterDeathAvailable: true,
};
